<template>
  <v-card color="green lighten-5">
    <v-card-title>
      <v-icon class="mr-3">fa-credit-card</v-icon>
      <span>{{$route.params.id}}</span>
      <span class="ml-10 text-uppercase">{{$t('card.prof.title')}}</span>
      <v-spacer></v-spacer>
      <v-btn icon @click="close" color="error">
        <v-icon>mdi-close-circle</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-form ref="form" :lazy-validation="true">
        <v-row>
          <v-col cols="12" md="2" class="hidden-sm-and-down">
            <v-img height="200px" width="161px" src="../../assets/profile.png"></v-img>
          </v-col>
          <v-col cols="12" md="10">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="item.first_name"
                  :label="$t('card.prof.first_name')"
                  :placeholder="$t('label.placeholder')"
                  background-color="yellow lighten-5"
                  color="black"
                  clearable
                  shaped
                  outlined
                  counter="32"
                  :rules="[v => v==null ||v.length<=32 || $t('error.lenght')]"
                ></v-text-field>
              </v-col>
              <v-col md="6" cols="12">
                <v-text-field
                  v-model="item.second_name"
                  clearable
                  background-color="yellow lighten-5"
                  color="black"
                  outlined
                  height="16px"
                  shaped
                  counter="32"
                  :label="$t('card.prof.second_name')"
                  :placeholder="$t('label.placeholder')"
                  :rules="[v => v==null ||v.length<=32 || $t('error.lenght')]"
                ></v-text-field>
              </v-col>
              <v-col md="6" cols="12">
                <v-text-field
                  v-model="item.reg_num"
                  clearable
                  outlined
                  background-color="yellow lighten-5"
                  color="black"
                  :label="$t('card.prof.reg_num')"
                  :placeholder="$t('label.placeholder')"
                  shaped
                  counter="32"
                  :rules="[v =>v==null || v.length<=32 || $t('error.lenght')]"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="item.company_name"
              clearable
              background-color="yellow lighten-5"
              color="black"
              outlined
              shaped
              counter="64"
              :label="$t('card.prof.company_name')"
              :placeholder="$t('label.placeholder')"
              :rules="[v => v==null ||v.length<=64 || $t('error.lenght')]"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="item.company_subname"
              clearable
              background-color="yellow lighten-5"
              color="black"
              outlined
              shaped
              counter="64"
              :label="$t('card.prof.company_subname')"
              :placeholder="$t('label.placeholder')"
              :rules="[v => v==null ||v.length<=64 || $t('error.lenght')]"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="item.additional"
              clearable
              background-color="yellow lighten-5"
              color="black"
              outlined
              shaped
              counter="4096"
              :rules="[v => v==null || v.length<=4096 || $t('error.lenght')]"
              :label="$t('card.prof.additional')"
              :placeholder="$t('label.placeholder')"
            ></v-textarea>
          </v-col>
          <v-col cols="12" v-if="alertMessage">
            <v-alert
              v-model="showAlert"
              border="left"
              colored-border
              type="error"
              elevation="2"
              :dismissible="true"
              transition="fade-transition"
            >{{alertMessage}}</v-alert>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        v-if="$store.getters.test('CardRecord.w')"
        color="blue darken-1"
        text
        @click="save"
      >{{$t('button.save')}}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
//import axios from "axios";
import app from "@/app.js";

export default {
  name: "CardEditor",
  props: {
    record: { type: Object, required: true },
    value: { type: Boolean }
  },
  data() {
    return {
      showAlert: false,
      alertMessage: "",
      item: { ...this.record }

      //      item: this.record
    };
  },
  watch: {
    record: {
      handler(nw) {
        this.item = { ...nw };
      },
      deep: true
    }
  },
  computed: {
    // item() {
    //   if (this.copy == null) this.copy = { ...this.record };
    //   return this.copy;
    // }
  },
  methods: {
    close() {
      this.item = { ...this.record };
      this.$emit("input", false);
    },
    save() {
      if (!this.$refs.form.validate()) return;
      let params = {
        id: this.item.id,
        firstName: this.item.first_name,
        secondName: this.item.second_name,
        companyName: this.item.company_name,
        companySubName: this.item.company_subname,
        regNumber: this.item.reg_num,
        additional: this.item.additional
        // pin: this.item.pin,
        // status: this.item.status,
        // validExt: this.item.valid.split(' ')[0],
      };
      app
        .update(this.item.id, "CardRecord", params)
        .then(() => {
          this.$emit("update", this.item);
          this.close();
        })
        .catch(error => {
          this.showAlertMessage(error);
        });
    },
    showAlertMessage(m) {
      if (m.errorMsg) {
        this.alertMessage = this.$t("error." + m.errorMsg);
      } else {
        this.alertMessage = JSON.stringify(m);
      }
      this.showAlert = true;
      setTimeout(() => {
        this.showAlert = false;
      }, 4000);
    }
  }
};
</script>

<style scoped>
.last-modified {
  text-align: right;
}
</style>